import React, { useCallback, useEffect, useMemo } from 'react'
import TextField from '@mui/material/TextField';
import DjangoCSRFToken from 'django-react-csrftoken';
import Button from '@mui/material/Button';
import { useDropzone } from 'react-dropzone';
import './ReimbursementSelect.scss';
import AmountConfirmationCard from '../card/AmountConfirmationCard';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../AuthProvider';
import { v4 as uuidv4 } from 'uuid';
import { Flex, Table } from 'antd';
import { baseUrl_PB, baseUrl_SPB } from '../../BaseUrl';
import EditableItem from '../Editable/EditableItems';
import { MenuItem, Select } from '@mui/material';
import { Circles } from 'react-loader-spinner'
import DescriptionSelector from '../tags/DescriptionSelector';
import PlanUpgradeDialog from '../../stripe/plans/PlanUpgradeDialog';
import Biodetails from '../bio/Biodetails';
const baseStyle = {
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: '20px',
  borderWidth: 0,
  borderRadius: 0,
  borderColor: '#eeeeee',
  borderRadius: '5px',
  borderStyle: 'dotted',
  backgroundColor: '#f12ef1',
  color: 'white',
  outline: 'none',
  transition: 'border .24s ease-in-out',
  marginBottom: '20px',
  fontSize: '16px',
  fontWeight: 'bold'
};

const focusedStyle = {
  borderColor: '#2196f3'
};

const acceptStyle = {
  borderColor: '#00e676'
};

const rejectStyle = {
  borderColor: '#ff1744'
};
function setCookie(cname, cvalue, minutes) {
  var d = new Date();
  d.setTime(d.getTime() + (minutes * 60 * 1000));
  var expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + "; " + expires;
}
// Function to get the CSRF token from cookies
function getCookie(name) {
  let cookieValue = null;
  if (document.cookie && document.cookie !== '') {
    const cookies = document.cookie.split(';');
    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i].trim();
      if (cookie.substring(0, name.length + 1) === (name + '=')) {
        cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
        break;
      }
    }
  }
  return cookieValue;
}

export default function ReimbursementSelect(props) {
  const [selectedRowKeys, setSelectedRowKeys] = React.useState([]);
  const [claimedAmountExtracted, setClaimedAmountExtracted] = React.useState(false);
  const [formData, setFormData] = React.useState({ claimant_name: '', claimed_amount: '', file: null, transaction_reference: 'TAX' ,additional_info:[]});
  const [reviewAttachmentData, setReviewAttachmentData] = React.useState({});
  const [reviewAttachmentDataArray, setReviewAttachmentDataArray] = React.useState([]);
  const [processing, setProcessing] = React.useState(false);
  const authContext = useAuth();
  const [open, setOpen] = React.useState(false);
  const [message, setMessage] = React.useState('');
  let navigate = useNavigate();
  useEffect(() => {
    console.log("I am here");
    console.log(authContext.additionalUserInfo.role);
    let fname = authContext.additionalUserInfo.firstName + " " + authContext.additionalUserInfo.lastName;
    setFormData({ ...formData, claimant_name: fname, transaction_reference: 'TAX' });
  }, [authContext.additionalUserInfo.firstName]);

  const onDrop = useCallback((acceptedFiles, fileRejections) => {
    if (fileRejections.length === 1) {
      fileRejections.forEach((file) => {
        file.errors.forEach((err) => {
          if (err.code === "file-too-large") {
            alert("The file size is too large to process for Effiez");
            return false;
          }
          else if (err.code === "file-invalid-type") {
            alert("Effiez doesn't accept this file type");
            return false;
          } else {
            alert("Something went wrong!");
            return false;

          }
        });

      });
    }
    else if (fileRejections.length > 1) {
      if (fileRejections.length > maxFileSize) {
        alert(`You can only upload a maximum of ${maxFileSize} files at a time`);
      } else {
        alert("Something went wrong, please check your files and try again");
      }
    } else {
      const postData = new FormData();
      acceptedFiles.forEach(file => {

        postData.append('file', file);
      });
      console.log(authContext.token);
      setProcessing(true);
      fetch(`${baseUrl_PB}/getcsrf/`, {
        method: 'GET',
        credentials: 'include',
      }).then(response => response.json())
        .then(data => {

          document.cookie = "csrftoken=" + data.csrfToken;
          fetch(`${baseUrl_PB}/hello/`, {
            method: 'POST',
            credentials: 'include',
            headers: {

              'X-CSRFToken': data.csrfToken,
              'Authorization': 'Bearer ' + authContext.token,

            },
            body: postData,
          })
            .then(response => response.json())
            .then(data => {

              //setFormData({ ...formData, claimed_amount: data.openAiResponse });
              if (data.length > 1) {
                //setReviewAttachmentDataArray(data);
                let x = data.map((item) => {
                  item['claimedAmount'] = item.openAiResponse;
                  item['key'] = uuidv4();
                  return item;
                });
                setReviewAttachmentDataArray(x);
              } else {
                setReviewAttachmentData(data[0]);
              }

              setClaimedAmountExtracted(true);
              setProcessing(false);
            })
            .catch(error => {
              console.error('Error:', error);
              setProcessing(false);
              alert("Something went wrong, please try again");
            });
        })
        .catch(error => {
          console.error('Error:', error);
          setProcessing(false);
          alert("Something went wrong, please try again");
        });
    }
  }, []);
  const maxSize = 10 * 1024 * 1024;
  const maxFileSize = 5;
  const { acceptedFiles, getRootProps, getInputProps, isFocused,
    isDragAccept,
    isDragReject, rejectedFiles } = useDropzone({
      onDrop,
      accept: {
        'image/png': ['.png'],
        'image/jpeg': ['.jpeg'],
        'image/jpg': ['.jpg'],
        'application/pdf': ['.pdf'],
        'image/gif': ['.gif'],
        'image/tiff': ['.tiff'],
        'image/bmp': ['.bmp'],
        'image/webp': ['.webp'],
        'image/svg+xml': ['.svg'],
        'image/x-icon': ['.ico'],
        'image/vnd.microsoft.icon': ['.ico'],
        'image/vnd.wap.wbmp': ['.wbmp'],
        'image/apng': ['.apng'],
        'image/x-jng': ['.jng'],
        'image/x-ms-bmp': ['.bmp'],
        'image/x-png': ['.png'],
        'image/x-portable-bitmap': ['.pbm'],
        'image/x-portable-graymap': ['.pgm'],
        'image/x-portable-pixmap': ['.ppm'],
        'image/x-xbitmap': ['.xbm'],
        'image/x-xpixmap': ['.xpm'],
        'image/x-xwindowdump': ['.xwd'],
        'image/bmp': ['.bmp'],
        'image/heic': ['.heic'],
        'image/heif': ['.heif'],
        'image/hej2': ['.hej2'],
        'image/hsj2': ['.hsj2'],
        'image/jp2': ['.jp2'],
        'image/jpe': ['.jpe'],
      },
      minSize: 0,
      maxSize,
      maxFiles: maxFileSize
    });
  const isFileTooLarge = rejectedFiles && rejectedFiles.length > 0 && rejectedFiles[0].size > maxSize;

  const style = useMemo(() => ({
    ...baseStyle,
    ...(isFocused ? focusedStyle : {}),
    ...(isDragAccept ? acceptStyle : {}),
    ...(isDragReject ? rejectStyle : {})
  }), [
    isFocused,
    isDragAccept,
    isDragReject
  ]);

  const handleClose = () => {

    setOpen(false);
  };
  const handleDownload = async () => {
    try {
      let f = null;
      acceptedFiles.map(file => {
        f = file;
      })


      // Step 5: Create a download link for the Blob
      const url = URL.createObjectURL(f);
      const a = document.createElement("a");
      a.href = url;

      // Step 6: Set the download attribute and trigger the download
      a.download = f.path;
      document.body.appendChild(a);
      a.click();

      // Step 7: Clean up the temporary URL
      document.body.removeChild(a);
      URL.revokeObjectURL(url);


    } catch (error) {

      // Step 2 (Error): Handle any other errors that may occur during processing
      alert("Something went wrong");

    }
  };


  const files = acceptedFiles.map(file => (
    <li key={file.path}>
      {file.path} - {file.size} bytes
    </li>
  ));

  const processClaimedAmount = (amount) => {
    setFormData({ ...formData, claimed_amount: amount });
  }

  const test = () => {
    console.log(formData.claimant_name);
  }
  // Calculate GST (10% of amount, if GST applies)
  const calculateGST = (amount) => {
    // If amount is not a number, return 0
    const amt = parseFloat(amount);
    if (isNaN(amt)) return 0;
    return amt * 0.1;
  };
  const calculateAmountExclGST = (amount) => {  
    return amount - (amount * 0.11);
  }
  const requestReimbursement = async () => {
    
    let openAiLargeResponseObject = JSON.parse(reviewAttachmentData.openAiLargeResponse);

    // Calculate GST (10% of claimed_amount)
    const gstValue = calculateGST(formData.claimed_amount);

    let dataToPost = {
      reimbursementId: uuidv4(),
      claimantId: authContext.user.username,
      claimantEmail: authContext.additionalUserInfo.email,
      claimantFullName: formData.claimant_name,
      claimedAmount: formData.claimed_amount,
      amountExclGST: calculateAmountExclGST(formData.claimed_amount),
      totalGST: gstValue,
      status: 'pending',
      amount: formData.claimed_amount,
      extractedAmount: reviewAttachmentData.openAiResponse,
      s3ConnectionUrl: reviewAttachmentData.s3ConnectionUrl,
      invoiceDate: reviewAttachmentData.date,
      fileName: reviewAttachmentData.fileName,
      createdDate: new Date(),
      createdBy: authContext.user.username,
      transactionReference: formData.transaction_reference,
      additionalInfo: formData.additional_info ? formData.additional_info.toString() : '',
      claimantManagerId: authContext.additionalUserInfo.reportingManagerId,
      documentContent: reviewAttachmentData.documentContent ? reviewAttachmentData.documentContent : '',
      supplierName: openAiLargeResponseObject && openAiLargeResponseObject.supplier_name ? openAiLargeResponseObject.supplier_name : '',
      openAiLargeResponse: reviewAttachmentData.openAiLargeResponse ? reviewAttachmentData.openAiLargeResponse : '',
      reviewAttachmentDataArray: reviewAttachmentDataArray,
    }
   
    try {
      const response = await fetch(`${baseUrl_SPB}/api/v1/reimburse/reimbursement`, {
        method: 'POST',

        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + authContext.token,
        },
        body: JSON.stringify(dataToPost),
      }).then(response => response.json()).then(data => {
        if(data.status==="failed"){
          console.log(data.message);
          setMessage(data.message);
          setOpen(true);
          return ;
        }else{
          navigate("/myreimbursements");
        }
      });

    } catch (error) {
      console.error('Error:', error);
      alert("Something went wrong, please try again");
    }
    
  }





  const onSelectChange = (newSelectedRowKeys) => {
    console.log('selectedRowKeys changed: ', newSelectedRowKeys);
    setSelectedRowKeys(newSelectedRowKeys);
  };
  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };
  const hasSelected = selectedRowKeys.length > 0;

  const handleChange = (event) => {
    setFormData({ ...formData, transaction_reference: event.target.value });
  };

  const onRemove = () => {
    setClaimedAmountExtracted(false);
    setReviewAttachmentDataArray([]);
    setReviewAttachmentData({});
  }
  return (
    
    <section className="container">
     
      {(authContext.role === 'ROLE_NEWU' || authContext.additionalUserInfo?.role === 'ROLE_NEWU' || !authContext.additionalUserInfo?.role) ?
        <Biodetails redirect="redirect" additionalUserInfo={authContext.additionalUserInfo} setAdditionalUserInfo={props.setAdditionalUserInfo} user={authContext.user}/>:
        <div>  
      <div class="createReimburseHeaderText"> Reimbursement/claim request:</div>
      {!claimedAmountExtracted ?
        (<div><div className="fileUploadField" {...getRootProps({ style })}>
          <input {...getInputProps()} />
          <DjangoCSRFToken />
          <p>{window.innerWidth > 599 ? 'Click' : 'Tap'} to upload a receipt</p>
          {isDragReject && "File type not accepted, sorry!"}
          {isFileTooLarge && (
            <div className="text-danger mt-2">
              File is too large.
            </div>
          )}
        </div>

        </div>)
        :
        (<div>
          {reviewAttachmentDataArray.length > 1 ?
            (<EditableItem dataSource={reviewAttachmentDataArray} />)
            : <div>
              <div className="rootContainer">
                <a className='aLink' onClick={handleDownload}>{files} </a>
                <Button className="downloadButton" variant="contained" onClick={onRemove}>Remove</Button>
              </div>
              <div>
                <TextField disabled className="textField" id="amount-claimed" label="Claimed amount" variant="outlined" value={formData.claimed_amount} />
                <TextField disabled className="textField" id="amount-x-claimed" label="Automatic Extracted amount" variant="outlined" value={reviewAttachmentData.openAiResponse} />
              </div>
              <AmountConfirmationCard opend={claimedAmountExtracted} processClaimedAmount={processClaimedAmount} claimedAmountD={reviewAttachmentData.openAiResponse} />
            </div>
          }

        </div>)

      }
      <div><p>Purpose (Transaction reference):</p></div>
      <Select className='selectField'
        labelId="demo-simple-select-label"
        id="demo-simple-select"
        value={formData.transaction_reference}
        label="transaction_reference"
        onChange={handleChange}
      >
        <MenuItem style={{}} value={'TAX'}>Tax Return</MenuItem>
        <MenuItem value={'EXPENSE'}>Expense</MenuItem>
        <MenuItem value={'PERSONAL'}>Personal</MenuItem>
        <MenuItem value={'ACCOUNT_PAYABLE'}>Account Payable</MenuItem>

      </Select>
     


     <DescriptionSelector formData={formData} setFormData={setFormData}/>

      <Button disabled={!claimedAmountExtracted} className="buttonField" variant="contained" onClick={requestReimbursement}>{processing ? 'processing...please wait' : 'Save'}</Button>

      {processing ?
        <div class="loading-state">
          <Circles
            height="60"
            width="60"

            color="blue"
            ariaLabel="audio-loading"
            wrapperStyle={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%,-50%)' }}

            visible={true}
          />
        </div> : ''}
      <aside>

      </aside>
      <PlanUpgradeDialog handleClose={handleClose} open={open} message={message} />
      </div>}
    </section>
  );
}

